export const environment = {
  CLIENT_ID: "222613446093-g6u87n8vjbjkde751bss44fh3mf0h0r6.apps.googleusercontent.com",
  
  REDIRECTION_URI: "http://localhost:3000/oauth-callback", // must match redirect URI in Google console
  BACKEND_URL: "http://localhost:3000",
  // Base_Url:"http://54.160.18.133:5000/api/dashboard-analytics"
  // Curl:"curl -H "DOMAIN-TOKEN: 7fefed7959d5a020753d0252002948fefb1762a4089c2e68d3b410818f3c3d1f1740996917" http://54.160.18.133:5000/api/dashboard-analytics"
};